import { LinearProgress, Stack, styled, Typography } from "@mui/material";
import { FC } from "react";

const LinearProgressStyled = styled(LinearProgress)(({ theme }) => ({
  height: "10px",
  borderRadius: "8px",
  color: theme.palette.secondary50.main,
}));

interface IProgressBarTitle {
  title: string;
  width?: string;
  completedPercentage: number;
}

const ProgressBarTitle: FC<IProgressBarTitle> = ({ title, width = "100%", completedPercentage }) => {
  return (
    <Stack spacing={2} sx={{ width }}>
      <Typography variant="heading.four" sx={{ fontWeight: "bold" }} data-testid="modalTitle">
        {title}
      </Typography>
      <LinearProgressStyled variant="determinate" value={completedPercentage} />
    </Stack>
  );
};

export { ProgressBarTitle };
